import { render, staticRenderFns } from "./Api.vue?vue&type=template&id=50ee940f&"
import script from "./Api.vue?vue&type=script&lang=ts&"
export * from "./Api.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports